// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import App from './App'
import http from './common/http'
import router from './router'
import Vuex from 'vuex'
import store from './store/store'
import QRCode2 from 'qrcode2'
import 'babel-polyfill'
import { UrlSearch } from '../static/js/url'
import MetaInfo from 'vue-meta-info'
import EventProxy from 'vue-event-proxy'
import { setCookie, getCookie, delCookie, checkID } from '../static/js/cookie'

import './assets/css/base.css'
import Vue from 'vue'
// import VueClipboard from 'vue-clipboard2'
Vue.use(Vuex)
// Vue.use(VueClipboard)
// 解决 ruoter un...
// import VueRouter from "vue-router";
// 解决两次访问相同路由地址报错
// const originalPush = VueRouter.prototype.push
// VueRouter.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch(err => err)
// }
Vue.use(EventProxy)
Vue.use(MetaInfo)
let Request = new UrlSearch()
Vue.prototype.$Request = Request
Vue.prototype.http = http
Vue.prototype.$cookieStore = {
  setCookie,
  getCookie,
  delCookie,
  checkID
}
Vue.config.productionTip = false
// 二维码
const QRCodeSC = (url, width, height) => {
  let qrcode = new QRCode2('qrcode', {
    width: width,
    height: height,
    text: url
  })
  return qrcode
}
Vue.prototype.$scrollTo = (x = 0, y = 0, type = 'instant') => {
  window.scrollTo({
    top: x,
    left: y,
    behavior: type // 滚动行为：smooth平滑滚动，instant瞬间滚动，默认值auto，等同于instant
  })
}
Vue.prototype.$QRCodeSC = QRCodeSC
window.$ = window.jQuery = window.jq = require('jquery')
// import $ from 'jquery'

// require('./assets/new/js/vendor/modernizr-2.8.3.min.js')

router.beforeEach((to, from, next) => {
  // chrome
  document.body.scrollTop = 0
  // firefox
  document.documentElement.scrollTop = 0
  // safari
  window.pageYOffset = 0
  next()
})

require('./assets/new/js/bootstrap.min.js')

require('./assets/new/js/owl.carousel.min.js')

// require('./assets/new/js/isotope.pkgd.min.js')

require('./assets/new/js/magnific.min.js')

require('./assets/new/js/venobox.min.js')

require('./assets/new/js/jquery.meanmenu.js')

require('./assets/new/js/form-validator.min.js')

require('./assets/new/js/plugins.js')

require('./assets/new/js/main.js')
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js